export default __webpack_public_path__ + "d889ef296d47b1121cfb3460e99c8fb6.png";